import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import type { TargetDetail } from '../outreachTypes';
import { findMessages as messages } from './findMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import styles from '../Outreach.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The curator's own rules, from their description or page (design outreach c2, prompt P3). */
const TargetRulesComponent: React.FC<{ rules: TargetDetail['rules'] }> = ({ rules }) => {
  const intl = useIntl();
  if (rules === null || (rules.noGenres.length === 0 && !rules.viaForm && rules.notes === null)) {
    return null;
  }
  return (
    <div className="d-flex flex-column gap-2" data-testid="target-rules">
      <span className={styles.eyebrow}>{intl.formatMessage(messages.rulesTitle)}</span>
      {rules.noGenres.length > 0 && (
        <div className={styles.rule}>
          {intl.formatMessage(messages.rulesNoGenres, { genres: rules.noGenres.join(', ') })}
        </div>
      )}
      {rules.viaForm && <div className={styles.rule}>{intl.formatMessage(messages.rulesViaForm)}</div>}
      {rules.notes !== null && <div className={styles.rule}>{rules.notes}</div>}
    </div>
  );
};

export const TargetRules = TypedMemo(TargetRulesComponent);
